import { createEvent, restore, sample } from 'effector'
import { Investor, InvestorsRequest, InvestorsResponse } from './types'
import { fx } from '../../../../../libs'

const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map((item) => {
      return [item[0], item[1]?.toLowerCase()]
    }),
  )
}

const isAllElementsOfSearchTextNotExist = (searchText: {
  [key: string]: string
}) => {
  return Object.values(searchText).every((item) => item === undefined)
}
export const investorsMounted = createEvent<InvestorsRequest>()

export const getInvestors = fx<InvestorsRequest, InvestorsResponse>({
  method: 'GET',
  url: `/strategy_subscription`,
})

export const $investors = restore<Investor[]>(
  getInvestors.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfInvestors = restore(
  getInvestors.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: investorsMounted,
  fn: ({ strategyId, limit, page, orderBy, orderDirection, searchText }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }
    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    let newObj = {}

    // @ts-ignore
    newObj['strategyId'] = strategyId
    // @ts-ignore
    newObj['deletedAt'] = 'null'

    if (!isAllElementsOfSearchTextNotExist(searchText)) {
      newObj = { ...newObj, ...mapSearchText(searchText) }
    }

    if (Object.keys(newObj).length) {
      // @ts-ignore
      query['where'] = `${JSON.stringify(newObj)}`
    }

    // @ts-ignore
    query['populate'] = JSON.stringify([
      'StrategySubscription',
      'StrategySubscription.account',
      'StrategySubscription.client',
    ])

    return {
      query,
    }
  },
  target: getInvestors,
})
